<script>
import EquipamentoCalibracao from '@/components/equipamento/EquipamentoCalibracao.vue'
import EquipamentoChangeCredentials from '@/components/equipamento/EquipamentoChangeCredentials.vue'
import EquipamentoEditForm from '@/components/equipamento/EquipamentoEditForm.vue'
import auth from '@/utils/auth'

const STATES = {
  EQUIPAMENTO: 'EQUIPAMENTO',
  CALIBRACAO: 'CALIBRACAO',
  INTEGRACAO: 'INTEGRACAO',
}

export default {
  name: 'EquipamentoConfiguracaoTab',
  components: {
    EquipamentoChangeCredentials,
    EquipamentoCalibracao,
    EquipamentoEditForm,
  },
  props: {
    equipamento: {
      type: Object,
      required: true,
    },
    localId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      STATES,
      state: auth.canEquipamentoEditar()
        ? STATES.EQUIPAMENTO
        : STATES.CALIBRACAO,
    }
  },
  computed: {
    stateToText() {
      if (!auth.canEquipamentoEditar()) {
        return {
          [STATES.CALIBRACAO]: 'Calibração',
        }
      }

      return {
        [STATES.EQUIPAMENTO]: 'Equipamento',
        [STATES.CALIBRACAO]: 'Calibração',
        [STATES.INTEGRACAO]: 'Integração',
      }
    },
  },
  watch: {
    state(newV, oldV) {
      if (newV !== oldV) {
        const routes = {
          [STATES.EQUIPAMENTO]: `/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/equipamento`,
          [STATES.CALIBRACAO]: `/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/calibracao`,
          [STATES.INTEGRACAO]: `/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/integracao`,
        }

        this.$router.push(routes[newV])
      }
    },
  },
  beforeMount() {
    const routes = {
      [`/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao`]:
        STATES.EQUIPAMENTO,
      [`/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/equipamento`]:
        STATES.EQUIPAMENTO,
      [`/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/calibracao`]:
        STATES.CALIBRACAO,
      [`/local/${this.localId}/equipamento/${this.equipamento.id}/editar/configuracao/integracao`]:
        STATES.INTEGRACAO,
    }

    const url = new URL(window.location)

    const state = routes[url.pathname]

    if (state && this.stateToText[state]) {
      this.state = state
    }
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-2">
        <div class="list-group pr-3">
          <div
            v-for="(value, key) in stateToText"
            :key="key"
            class="config-tab"
            :class="{
              'config-tab-selected': state === key,
            }"
            @click="state = key"
          >
            <p class="config-text">
              {{ value }}
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <transition name="fade-slide-up" mode="out-in">
          <EquipamentoEditForm
            v-if="state === STATES.EQUIPAMENTO"
            :equipamento-usuario="equipamento.usuario"
            :equipamento="equipamento"
            @change="() => $emit('change')"
          />

          <EquipamentoCalibracao
            v-else-if="state === STATES.CALIBRACAO"
            :local-id="localId"
            :equipamento="equipamento"
            @change="() => $emit('change')"
          />

          <EquipamentoChangeCredentials
            v-else-if="state === STATES.INTEGRACAO"
            :local-id="localId"
            :equipamento-usuario="equipamento.usuario"
            :equipamento-id="equipamento.id"
          />
        </transition>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.list-group {
  border-right: 1px solid #e6eaed;
}

.config-text {
  padding: 5%;
  font-weight: 500;
}

.config-tab {
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background-color: #e6eaed;
  }
}

.config-tab-selected {
  background-color: #f1f5f9;
}
</style>
